import {useTranslation} from 'react-i18next'
import {KTSVG} from '../../../_metronic/helpers'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {orderSelector, setOrderFilter} from '../../../redux/slices/orderSlices'

export const RowHeadOrder = () => {
  const {t} = useTranslation()
  const {orderFilter: filter} = useAppSelector(orderSelector)
  const dispatch = useAppDispatch()

  const iconSortOrderNumber =
    filter?.po_number_orderby === 'asc'
      ? '/media/icons/duotune/sort-up-alt.svg'
      : '/media/icons/duotune/sort-down-alt.svg'

  const iconSortCustomer =
    filter?.customer_name_orderby === 'asc'
      ? '/media/icons/duotune/sort-up-alt.svg'
      : '/media/icons/duotune/sort-down-alt.svg'

  const handleSortChange = (value: Partial<typeof filter>) => {
    dispatch(setOrderFilter({...filter, ...value}))
  }

  return (
    <tr>
      <th>{t('order-aksi')}</th>
      <th>
        {t('order-no')}
        <button
          className='bg-transparent border-0'
          title={t('Sort')}
          onClick={() => {
            const po_number_orderby = filter?.po_number_orderby === 'asc' ? 'desc' : 'asc'
            handleSortChange({po_number_orderby})
          }}
        >
          <KTSVG path={iconSortOrderNumber} className='svg-icon-3 ms-1' />
        </button>
      </th>
      <th>{t('order-tanggal')}</th>
      <th>
        {t('order-pelanggan')}
        <button
          className='bg-transparent border-0'
          title={t('Sort')}
          onClick={() => {
            const customer_name_orderby = filter?.customer_name_orderby === 'asc' ? 'desc' : 'asc'
            handleSortChange({
              customer_name_orderby,
            })
          }}
        >
          <KTSVG path={iconSortCustomer} className='svg-icon-3 ms-1' />
        </button>
      </th>
      <th>Sales Org</th>
      <th>{t('order-perihal')}</th>
      <th>{t('Sektor')}</th>
      <th>{t('Total Kuantum')}</th>
      <th>{t('Total Price')}</th>
      <th>Status</th>
    </tr>
  )
}

RowHeadOrder.defaultProps = {
  role: 'null',
}
